import React from "react";
import { Formik, Form, Field } from "formik";
import Axios from "../../Helpers/Universal/Axios/Axios";
import API from "../../Helpers/Constants/EndPoints/Api";
import { AppVersionSchema } from "../../Helpers/Constants/Schemas";

const AppVersionModal = ({ modalData, setModalData, setVisible, setData }) => {
  const isUpdate = !!modalData?.data?._id;

  const initialValues = isUpdate
    ? {
      platform: modalData.data.platform || "android",
      currentVersion: modalData.data.currentVersion || "",
      buildNumber: modalData.data.buildNumber || "",
      minSupportedVersion: modalData.data.minSupportedVersion || "",
      minSupportedBuildNumber: modalData.data.minSupportedBuildNumber || "",
      updateUrl: modalData.data.updateUrl || "",
      isSkippable: modalData.data.isSkippable || false,
      releaseNotes: modalData.data.releaseNotes || "",
    }
    : {
      platform: "android",
      currentVersion: "",
      buildNumber: "",
      minSupportedVersion: "",
      minSupportedBuildNumber: "",
      updateUrl: "",
      isSkippable: false,
      releaseNotes: "",
    };

  const hide = () => setModalData((prev) => ({ ...prev, visible: false }));

  const handleSubmit = async (values) => {
    try {
      setVisible((prev) => ({ ...prev, loader: true }));

      const payload = { ...values };
      if (isUpdate) {
        payload.versionId = modalData.data._id;
      }

      const endpoint = isUpdate ? API.APP_VERSION.UPDATE : API.APP_VERSION.CREATE;
      const method = isUpdate ? "patch" : "post";

      const { status, data } = await Axios[method](endpoint, payload);

      if (status) {
        // Correctly handle the nested structure: data.data based on provided JSON
        // data here is res.data.data from the raw API response
        const actualRecord = data?.data || data;

        if (isUpdate) {
          setData((prev) =>
            prev.map((item) => (item._id === modalData.data._id ? actualRecord : item))
          );
        } else {
          setData((prev) => [actualRecord, ...prev]);
        }
        hide();
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
    }
  };

  return (
    <div className="bg_viewpopup" style={{ zIndex: "999999" }}>
      <div
        className="successfullModal successfull p-4 pb-0 w-50 top-50 start-50 end-0 border border-secondary rounded text-center position-absolute"
        style={{ transform: "translate(-50%, -50%)", maxHeight: "90vh", overflowY: "auto" }}
      >
        <div>
          <label className="cross-btns" onClick={hide}>
            ×
          </label>
        </div>
        <div className="modal-body mt-0 p-0 text-start">
          <h5 className="mb-4 text-center text-white">{isUpdate ? "Update App Version" : "Create App Version"}</h5>
          <Formik
            initialValues={initialValues}
            validationSchema={AppVersionSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, errors, touched }) => (
              <Form className="page-from p-0">
                <div className="inner-form m-0" style={{ background: "transparent" }}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="text-white">Platform</label>
                      <Field as="select" name="platform" className="form-control bg-dark text-white border-secondary">
                        <option value="android">Android</option>
                        <option value="ios">iOS</option>
                      </Field>
                      {errors.platform && touched.platform && <div className="text-danger small">{errors.platform}</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="text-white">Current Version</label>
                      <Field name="currentVersion" className="form-control bg-dark text-white border-secondary" placeholder="e.g. 1.0.0" />
                      {errors.currentVersion && touched.currentVersion && <div className="text-danger small">{errors.currentVersion}</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="text-white">Build Number</label>
                      <Field name="buildNumber" type="number" className="form-control bg-dark text-white border-secondary" placeholder="e.g. 1" />
                      {errors.buildNumber && touched.buildNumber && <div className="text-danger small">{errors.buildNumber}</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="text-white">Min Supported Version</label>
                      <Field name="minSupportedVersion" className="form-control bg-dark text-white border-secondary" placeholder="e.g. 1.0.0" />
                      {errors.minSupportedVersion && touched.minSupportedVersion && <div className="text-danger small">{errors.minSupportedVersion}</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="text-white">Min Supported Build Number</label>
                      <Field name="minSupportedBuildNumber" type="number" className="form-control bg-dark text-white border-secondary" placeholder="e.g. 1" />
                      {errors.minSupportedBuildNumber && touched.minSupportedBuildNumber && <div className="text-danger small">{errors.minSupportedBuildNumber}</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-check mt-4">
                        <Field type="checkbox" name="isSkippable" className="form-check-input" id="isSkippable" />
                        <label className="form-check-label text-white" htmlFor="isSkippable">
                          Is Skippable
                        </label>
                      </div>
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="text-white">Update URL</label>
                      <Field name="updateUrl" className="form-control bg-dark text-white border-secondary" placeholder="https://..." />
                      {errors.updateUrl && touched.updateUrl && <div className="text-danger small">{errors.updateUrl}</div>}
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="text-white">Release Notes</label>
                      <Field as="textarea" name="releaseNotes" className="form-control bg-dark text-white border-secondary" rows="3" />
                      {errors.releaseNotes && touched.releaseNotes && <div className="text-danger small">{errors.releaseNotes}</div>}
                    </div>

                    <div className="col-md-12 mb-3 mt-3 text-center">
                      <button
                        disabled={isSubmitting}
                        className="btn bg-gradient-dark d-block btn-lg mb-1 w-100"
                        type="submit"
                      >
                        {isUpdate ? "Update" : "Create"}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default AppVersionModal;
